import { Col, Container, Row } from "@amzn/stencil-react-components/layout";
import { Spinner } from "@amzn/stencil-react-components/spinner";
import { TabBar, TabPanel, TabSwitcher, useTabs } from "@amzn/stencil-react-components/tabs";
import { Text } from "@amzn/stencil-react-components/text";
import ListModalButton from "common/components/ListModal/ListModalButton";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { useLists } from "hooks/ListsContext";
import { Visibility } from "lib/models/list-models";
import { UserPermissions } from "lib/services";
import React, { FC, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { List } from "./List";
const ListsPage: FC = () => {
  const history = useHistory();
  const { lists, loading, getMyLists } = useLists();
  const tabs = [
    getString("lists.tabs.myLists"),
    //getString("lists.tabs.sharedLists"), this feature is not yet implemented
    getString("lists.tabs.highlights"),
  ];

  const toggleLists = UserPermissions.current.hasPermission(PERMISSIONS.TOGGLE_LISTS);
  const { tabBarProps, tabSwitcherProps } = useTabs({ tabs });

  const allowedDomain = window.location.href.includes("aiforme") ? "aiforme" : "software";

  useEffect(() => {
    if (toggleLists) {
      getMyLists({ includeItemDetails: true, visibility: Visibility.PRIVATE });
    }
  }, [getMyLists]);

  if (!toggleLists) {
    history.push("/");
    return null;
  }

  const renderMyLists = () => {
    return (
      <Col gridGap="S300">
        {loading && <Spinner />}
        {!loading &&
          lists.map(
            (list, index) => list.allowedDomains.includes(allowedDomain) && <List key={`List-${index}`} {...list} />
          )}
        {!loading && lists.length == 0 && (
          <Text fontSize="T200" color="neutral90">
            {getString("lists.noLists")}
          </Text>
        )}
      </Col>
    );
  };

  const renderHighlights = () => {
    return (
      <Col gridGap="S300">
        {loading && <Spinner />}
        {!loading &&
          lists.map((list, index) => list.visibility === Visibility.PUBLIC && <List key={`List-${index}`} {...list} />)}
        {!loading && lists.filter((list) => list.visibility === Visibility.PUBLIC).length == 0 && (
          <Text fontSize="T200" color="neutral90">
            {getString("lists.noLists")}
          </Text>
        )}
      </Col>
    );
  };

  return (
    <Col>
      <PageMainContainer>
        <Container paddingTop={32} paddingBottom={32}>
          <Col gridGap={32}>
            <Row justifyContent="space-between">
              <Text fontSize="T400" fontWeight="bold" color="neutral90">
                {getString("lists.title")}
              </Text>
              <ListModalButton />
            </Row>
            <Text fontSize="T200" color="neutral90">
              {getString("lists.description")}
            </Text>

            <TabBar {...tabBarProps} />
            <TabSwitcher {...tabSwitcherProps}>
              <TabPanel value={getString("lists.tabs.myLists")}>{renderMyLists()}</TabPanel>
              <TabPanel value={getString("lists.tabs.highlights")}>{renderHighlights()}</TabPanel>
            </TabSwitcher>
          </Col>
        </Container>
      </PageMainContainer>
    </Col>
  );
};

export default ListsPage;
